import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./i18n";

// Pages
import {
  HomePage,
  ShowDeDronesPage,
  PantallaDeAguaPage,
  SkyMeetsWaterPage,
  DronesParaEventosPage,
  ActivacionesDeMarcaPage,
  EfectosEspecialesPage,
  LanzamientosInmobiliariosPage,
  EventosMasivosPage,
  EventosPrivadosPage,
  AdminPage
} from "./pages";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/show-de-drones" element={<ShowDeDronesPage />} />
          <Route path="/pantalla-de-agua" element={<PantallaDeAguaPage />} />
          <Route path="/elements" element={<SkyMeetsWaterPage />} />
          <Route path="/efectos-especiales" element={<EfectosEspecialesPage />} />
          <Route path="/drones-para-eventos" element={<DronesParaEventosPage />} />
          <Route path="/activaciones-de-marca" element={<ActivacionesDeMarcaPage />} />
          <Route path="/lanzamientos-inmobiliarios" element={<LanzamientosInmobiliariosPage />} />
          <Route path="/eventos-masivos" element={<EventosMasivosPage />} />
          <Route path="/eventos-privados" element={<EventosPrivadosPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
